export var TaxType;
(function (TaxType) {
    TaxType[TaxType["INCLUDED"] = 0] = "INCLUDED";
    TaxType[TaxType["ADDED"] = 1] = "ADDED";
    TaxType[TaxType["ADDED_AT_CHECKOUT"] = 2] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
export var FeeType;
(function (FeeType) {
    FeeType[FeeType["FEE_ADDED"] = 0] = "FEE_ADDED";
    FeeType[FeeType["FEE_INCLUDED"] = 1] = "FEE_INCLUDED";
    FeeType[FeeType["FEE_ADDED_AT_CHECKOUT"] = 2] = "FEE_ADDED_AT_CHECKOUT";
})(FeeType || (FeeType = {}));
export var CheckoutType;
(function (CheckoutType) {
    CheckoutType[CheckoutType["UNKNOWN_CHECKOUT_TYPE"] = 0] = "UNKNOWN_CHECKOUT_TYPE";
    CheckoutType[CheckoutType["EVENTS_APP"] = 1] = "EVENTS_APP";
    CheckoutType[CheckoutType["ECOMM_PLATFORM"] = 2] = "ECOMM_PLATFORM";
})(CheckoutType || (CheckoutType = {}));
export var EventStatus;
(function (EventStatus) {
    EventStatus[EventStatus["SCHEDULED"] = 0] = "SCHEDULED";
    EventStatus[EventStatus["STARTED"] = 1] = "STARTED";
    EventStatus[EventStatus["ENDED"] = 2] = "ENDED";
    EventStatus[EventStatus["CANCELED"] = 3] = "CANCELED";
    EventStatus[EventStatus["DRAFT"] = 4] = "DRAFT";
})(EventStatus || (EventStatus = {}));
export var EventType;
(function (EventType) {
    EventType[EventType["NA_EVENT_TYPE"] = 0] = "NA_EVENT_TYPE";
    EventType[EventType["RSVP"] = 1] = "RSVP";
    EventType[EventType["TICKETS"] = 2] = "TICKETS";
    EventType[EventType["EXTERNAL"] = 3] = "EXTERNAL";
    EventType[EventType["NO_REGISTRATION"] = 4] = "NO_REGISTRATION";
    EventType[EventType["RSVP_AND_TICKETS"] = 5] = "RSVP_AND_TICKETS";
})(EventType || (EventType = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus[RegistrationStatus["NA_REGISTRATION_STATUS"] = 0] = "NA_REGISTRATION_STATUS";
    RegistrationStatus[RegistrationStatus["CLOSED"] = 1] = "CLOSED";
    RegistrationStatus[RegistrationStatus["CLOSED_MANUALLY"] = 2] = "CLOSED_MANUALLY";
    RegistrationStatus[RegistrationStatus["OPEN_RSVP"] = 3] = "OPEN_RSVP";
    RegistrationStatus[RegistrationStatus["OPEN_RSVP_WAITLIST"] = 4] = "OPEN_RSVP_WAITLIST";
    RegistrationStatus[RegistrationStatus["OPEN_TICKETS"] = 5] = "OPEN_TICKETS";
    RegistrationStatus[RegistrationStatus["OPEN_EXTERNAL"] = 6] = "OPEN_EXTERNAL";
    RegistrationStatus[RegistrationStatus["SCHEDULED_RSVP"] = 7] = "SCHEDULED_RSVP";
    RegistrationStatus[RegistrationStatus["OPEN_RSVP_AND_TICKETS"] = 8] = "OPEN_RSVP_AND_TICKETS";
})(RegistrationStatus || (RegistrationStatus = {}));
export var VisitorType;
(function (VisitorType) {
    VisitorType[VisitorType["VISITOR"] = 0] = "VISITOR";
    VisitorType[VisitorType["MEMBER"] = 1] = "MEMBER";
    VisitorType[VisitorType["VISITOR_OR_MEMBER"] = 2] = "VISITOR_OR_MEMBER";
})(VisitorType || (VisitorType = {}));
export var ConferenceType;
(function (ConferenceType) {
    ConferenceType[ConferenceType["MEETING"] = 0] = "MEETING";
    ConferenceType[ConferenceType["WEBINAR"] = 1] = "WEBINAR";
})(ConferenceType || (ConferenceType = {}));
export var EventFieldset;
(function (EventFieldset) {
    EventFieldset[EventFieldset["FULL"] = 0] = "FULL";
    EventFieldset[EventFieldset["DETAILS"] = 1] = "DETAILS";
    EventFieldset[EventFieldset["TEXTS"] = 2] = "TEXTS";
    EventFieldset[EventFieldset["REGISTRATION"] = 3] = "REGISTRATION";
    EventFieldset[EventFieldset["URLS"] = 4] = "URLS";
    EventFieldset[EventFieldset["FORM"] = 5] = "FORM";
    EventFieldset[EventFieldset["DASHBOARD"] = 6] = "DASHBOARD";
    EventFieldset[EventFieldset["FEED"] = 7] = "FEED";
    EventFieldset[EventFieldset["ONLINE_CONFERENCING_SESSION"] = 8] = "ONLINE_CONFERENCING_SESSION";
    EventFieldset[EventFieldset["SEO_SETTINGS"] = 9] = "SEO_SETTINGS";
    EventFieldset[EventFieldset["AGENDA"] = 10] = "AGENDA";
    EventFieldset[EventFieldset["CATEGORIES"] = 11] = "CATEGORIES";
    EventFieldset[EventFieldset["CUSTOMIZABLE_TICKETS"] = 12] = "CUSTOMIZABLE_TICKETS";
    EventFieldset[EventFieldset["BADGES"] = 13] = "BADGES";
})(EventFieldset || (EventFieldset = {}));
export var OrderType;
(function (OrderType) {
    OrderType[OrderType["UNASSIGNED_TICKETS"] = 0] = "UNASSIGNED_TICKETS";
    OrderType[OrderType["ASSIGNED_TICKETS"] = 1] = "ASSIGNED_TICKETS";
})(OrderType || (OrderType = {}));
//# sourceMappingURL=events.js.map